<div class="logo-container">
	<img class="img" src="/assets/img/dropbox-sign-plus-procore.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- SCREEN 2.2 -->
<div [ngClass]="{'hidden': loading }">
	<div class="wizard-title">PURCHASE SETUP</div>
	<form #f="ngForm" [formGroup]="form">
		<div class="form-container">
			<div class="form-text-container">What type of subscription would you like to purchase?</div>
			<select #selectSubscriptionType formControlName="subscriptionType" id="subscriptionType" (change)="changeSubscriptionType($event)">
				<option value="shared">Shared</option>
				<option value="dedicated">Dedicated</option>
				<option value="connector">Connector-only</option>
			</select>

			<div class="subscription-details-container">
				<div [ngClass]="{'hidden': subscriptionType !== 'shared' }">With a shared subscription (our most popular model), Shake IT manages the Dropbox Sign environment, provisioning one or more isolated teams for your organization.</div>
				<div [ngClass]="{'hidden': subscriptionType !== 'shared' }" class="last">While you don’t manage users or teams directly, this model provides access to Dropbox Sign Premium features at a lower price point. Many of our customers select this option initially due to a lower entry cost and smaller / more granular volume options.</div>
				<div [ngClass]="{'hidden': subscriptionType !== 'dedicated' }">With a dedicated subscription, your organization owns and manages its own Dropbox Sign environment. You have full control over users, teams, and configuration.</div>
				<div [ngClass]="{'hidden': subscriptionType !== 'dedicated' }" class="last">This option requires additional steps to provision a dedicated Dropbox Sign account. After pressing Generate Quote, an order will be placed and additional communications will be required over e-mail.</div>
				<div [ngClass]="{'hidden': subscriptionType !== 'connector' }" class="last">A connector only subscription requires the customer to “bring their own” Dropbox Sign subscription. This option is intended for customers who already have a Dropbox Sign subscription they wish to integrate with Procore.</div>
			</div>

			<div [ngClass]="{'hidden': subscriptionType !== 'shared' && subscriptionType !== 'connector' }">
				<div class="form-text-container">How often would you like to be billed?​</div>
				<div>
					<select #selectBillingType formControlName="billingType" id="billingType" (change)="changeBillingType($event)">
						<option value="year">Annually</option>
						<option value="month">Monthly</option>
					</select>
				</div>
			</div>

			<div [ngClass]="{'hidden': subscriptionType !== 'shared' && subscriptionType !== 'connector' }">
				<div class="form-text-container">How many signatures will you send per <span *ngIf="billingType == 'year'">year</span><span *ngIf="billingType == 'month'">month</span>?​</div>
				<input type="number" #inputSignatures formControlName="inputSignatures" id="inputSignatures" [ngClass]="{'valid': inputSignaturesValid == true, 'invalid': inputSignaturesValid == false}" (change)="calculatePrice()" (keyup)="changeInputSignatures($event)" />
			</div>

			<div [ngClass]="{'hidden': subscriptionType !== 'dedicated' }">
				<div class="form-text-container">How many signatures will you send per year?​</div>
				<select #selectSignatures formControlName="selectSignatures" id="selectSignatures" (change)="changeSelectSignatures($event)">
					<option value="1200">1200</option>
					<option value="3000">3000</option>
					<option value="6000">6000</option>
					<option value="9000">9000</option>
					<option value="12000">12000</option>
					<option value="24000">24000</option>
					<option value="36000">36000</option>
					<option value="60000">60000</option>
				</select>
			</div>

			<div [ngClass]="{'hidden': subscriptionType !== 'dedicated' }">
				<div class="form-text-container">Would you like a <a href="https://sign.dropbox.com/products/dropbox-sign/pricing" target="_blank">standard or premium</a> Dropbox Sign account?​</div>
				<div>
					<select #selectStandardOrPremium formControlName="standardOrPremium" id="standardOrPremium" (change)="changeStandardOrPremium($event)">
						<option value="standard">Standard</option>
						<option value="premium">Premium</option>
					</select>
				</div>
			</div>

			<div class="cost-container">Cost:
				<span *ngIf="loadingCalculatePrice"><i class="fas fa-spinner fa-spin"></i></span>
				<span *ngIf="!cost && !loadingCalculatePrice">--</span>
				<span *ngIf="cost && !loadingCalculatePrice">${{ cost }}</span>
			</div>

			<button (click)="selectCreateQuote()" [disabled]="!form.valid">Generate Quote</button>
			<button (click)="selectShowQuotes()" *ngIf="contextService.quotes.length > 0">Show Existing Quotes</button>
			<button class="secondary" (click)="selectBack()">Back</button>
		</div>
	</form>
</div>